<template>
<div class="nav-total-content">
    <!-- 每一块的导航 -->
    <nav class="common-nav-content" id="jude-nav-content">
        <ul :style="getStyle">
        <li
            v-for="(item, index) in sonNavData.navArr"
            :key="index"
        >
            <a 
            :href="'#'+item.id"
            @click.prevent="toAnchorPoint(item.id)"
            >{{item.name}}
            </a>
        </li>
        </ul>
    </nav>

    <!-- 脱离文本流居顶的nav -->
    <transition name="fadeFast">
        <nav 
            v-show="sonNavData.showFixeNav"
            :class="sonNavData.showFixeNav && ['common-nav-content', 'nav-content-fixed']"
            id="nav-content-fixed"
        >
        <ul :style="getStyle">
            <li
            v-for="(item, index) in sonNavData.navArr"
            :key="index"
            >
            <a 
                :href="'#'+item.id"
                @click.prevent="toAnchorPoint(item.id)"
            >{{item.name}}
            </a>
            </li>
        </ul>
        </nav>
    </transition>
</div>

</template>

<script>
import $ from 'jquery';
export default {
    name: 'sonNav',
    props: {
        sonNavData: Object
    },
    computed: {
        getStyle() {
            let style = `width: ${this.sonNavData.ulWidth};`
            return style;
        }
    },
    data(){
        return {}
    },
    methods: {
        toAnchorPoint( id ) {
            const 
            top = $(`#${id}`).offset().top + $("body").scrollTop(),
            parentObj = $(`#${id}`);
            
            // ipadScreen = innerWidth < 1000 && innerWidth > 767,
            // ipadPadding = ipadScreen ? 22 : 0;
            // console.log(ipadScreen);

            // console.log(id);

            if (!$(parentObj).hasClass('weakFadeInUpLong')) {
                document.getElementsByTagName('body')[0].scrollTop = top - this.sonNavData.aniDistance;
            } else {
                document.getElementsByTagName('body')[0].scrollTop = top;
            }
        },
    }
}
</script>
<style lang="less" scoped>
*{
    margin: 0;
    padding: 0;
}
li{
    list-style: none;
}
.common-nav-content{
    width: 100%;
    height: 72px;
    background: #FFFFFF;
    box-shadow: 0px -1px 0px 0px rgba(225,225,225,1);
    .allCenter;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
    

    &.nav-content-fixed{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
    }


    ul{
        // width: 512px;
        .spaceBetweenX;

        li{
            // width: 64px;
            height: 100%;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #666;

            a{
                color: #666;
                font-family: PingFangSC-Regular, PingFang SC;
                
                &.active{
                color: #222;
                font-family: PingFangSC-Medium, PingFang SC;
                }
            }
        }
    }
}
</style>
